module.exports = __webpack_public_path__ + "img/principal.03003ced.png";